import { jwtDecode } from 'jwt-decode'

export const isAuthorized = (keycloak, roles) => {
  if (keycloak && roles) {
    return roles.some((role) => {
      const realm = keycloak.hasRealmRole(role)
      const resource = keycloak.hasResourceRole(role)
      return realm || resource
    })
  }

  return false
}

export const isTokenExpired = (token) => {
  if (!token) {
    return true
  }

  try {
    const decoded = jwtDecode(token)
    const currentTime = Math.floor(Date.now() / 1000)
    return decoded.exp < currentTime
  } catch (_) {
    console.log(_)
    return true
  }
}
